export default {
	get: ($parent, selector) => $parent.querySelector(`[wp-js-selector="${selector}"]`),
	getAll: ($parent, selector) => $parent.querySelectorAll(`[wp-js-selector="${selector}"]`),
	getComponent: ($parent, selector) => $parent.querySelector(`[wp-js-component="${selector}"]`),
	getAllComponents: ($parent, selector) =>
		$parent.querySelectorAll(`[wp-js-component="${selector}"]`)
};
